import React from 'react'

import { useSearchTermsQuery } from '../../../requests/analytics'
import { Skeleton } from '../../../components/Skeleton'
import './SearchTermsAnalytics.css'

export const SearchTermsAnalytics: React.FC = () => {
  const { data: searchTerms = [], isLoading } = useSearchTermsQuery()

  return (
    <div className="search-terms-analytics">
      <h3>Search Terms Analytics</h3>
      <p>
        Folder search terms from users that resulted in no folders being found.
      </p>
      <table className="search-terms-table">
        <thead>
          <tr>
            <th>Search Term</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <tr key={`skeleton-${index}`}>
                <td>
                  <Skeleton width={200} />
                </td>
                <td>
                  <Skeleton width={50} />
                </td>
              </tr>
            ))
          ) : searchTerms.length === 0 ? (
            <tr>
              <td colSpan={2}>No search terms found</td>
            </tr>
          ) : (
            searchTerms.map((item, index) => (
              <tr key={`${item.searchTerm}-${index}`}>
                <td>{item.searchTerm}</td>
                <td>{item.count}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
